export default "__VITE_ASSET__BJqfsNbx__"